import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AnalyticsLoader() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/public`).then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!settings?.ga4_id || window.__ga4Loaded) return;
    window.__ga4Loaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${settings.ga4_id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", settings.ga4_id);
  }, [settings]);

  if (!settings?.google_site_verification) return null;
  return (
    <Helmet>
      <meta name="google-site-verification" content={settings.google_site_verification} />
    </Helmet>
  );
}

export const trackEvent = (name, params = {}) => {
  if (window.gtag) window.gtag("event", name, params);
};
